<!--
  The avatar is decorative (aria-hidden), so the label carries the name. It says what the control is,
  not "Show user menu": whether the panel is shown is `aria-expanded`'s job. The panel is a dialog.
-->
<button
  #overlayTrigger="cdkOverlayOrigin"
  aria-haspopup="dialog"
  aria-label="Account menu"
  cdkOverlayOrigin
  class="user-overlay-select-btn"
  type="button"
  [attr.aria-controls]="profileOverlay.isOpen() ? panelId : null"
  [attr.aria-expanded]="profileOverlay.isOpen()"
  (click)="profileOverlay.toggle()"
>
  @if (isLoading()) {
    <at-skeleton />
  } @else {
    <at-avatar [name]="username()" />
  }
</button>

<at-overlay
  #profileOverlay
  panelClass="user-menu-panel"
  scrollStrategy="close"
  [ariaLabelledBy]="headingId"
  [trigger]="overlayTrigger"
>
  <app-user-profile-overlay
    [email]="email()"
    [headingId]="headingId"
    [id]="panelId"
    [isUserLoading]="isLoading()"
    [username]="username()"
    (close)="profileOverlay.close()"
    (logout)="onLogout()"
  />
</at-overlay>
